'use strict';

/*
 * campaignSnapshot.js -- carries the visitor's campaign tags into the Platinum Partner page's form.
 * Contract: specs/004-platinum-partner-conversion/contracts/analytics-events.md ("Campaign snapshot").
 *
 * capture(): when the URL carries at least one non-empty utm_source/medium/campaign/content, store all four
 *            (cleaned) in sessionStorage. A URL without tags never writes, so a known value is never replaced
 *            with blanks, and the tags survive the visitor reading a case study and coming back via the menu.
 * fill():    for each [data-campaign-fields] wrapper (blockForm.cshtml maps query key -> Forms field Id), put
 *            the snapshot into the matching hidden inputs; otherwise clean the server-rendered default.
 *
 * Values are cleaned, never rejected - a hidden field must never make a submission fail. Tab-scoped, no
 * cookies, no analytics; the values leave the browser only in the visitor's own form submission.
 */

var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
var STORAGE_KEY = 'pw.campaign';

function clean(value) {
    return String(value || '').trim().replace(/[^A-Za-z0-9 ._~+\-]/g, '').slice(0, 100);
}

function fromUrl() {
    var params = new URLSearchParams(window.location.search);
    var tags = {};
    var any = false;
    for (var i = 0; i < KEYS.length; i++) {
        tags[KEYS[i]] = clean(params.get(KEYS[i]));
        if (tags[KEYS[i]]) {
            any = true;
        }
    }
    return any ? tags : null;
}

function readStored() {
    try {
        var raw = window.sessionStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch (err) {
        return null;
    }
}

function capture() {
    var tags = fromUrl();
    if (!tags) {
        return;
    }
    try {
        window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(tags));
    } catch (err) {
        // Storage unavailable (private mode, blocked): fill() falls back to the current URL.
    }
}

function fill() {
    var wrappers = document.querySelectorAll('[data-campaign-fields]');
    if (!wrappers.length) {
        return;
    }
    var snapshot = readStored() || fromUrl() || {};

    for (var w = 0; w < wrappers.length; w++) {
        var map;
        try {
            map = JSON.parse(wrappers[w].getAttribute('data-campaign-fields'));
        } catch (err) {
            continue;
        }
        for (var i = 0; i < KEYS.length; i++) {
            var fieldId = map && map[KEYS[i]];
            if (!fieldId) {
                continue;
            }
            var input = wrappers[w].querySelector('input[type="hidden"][name="' + CSS.escape(fieldId) + '"]');
            if (!input) {
                continue;
            }
            var stored = clean(snapshot[KEYS[i]]);
            input.value = stored || clean(input.value);
        }
    }
}

module.exports = { capture: capture, fill: fill, clean: clean };
